
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetCategoryApi } from "../redux/actions/teams/members/GetCategoryAction";
import { AddUsers } from "../redux/actions/teams/members/AddUserAction";
import { PulseLoader } from "react-spinners";
import { Eye, EyeOff } from "lucide-react";

 
const AddUser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
   const { loading, error,success } = useSelector((state) => state.addUser);
const [showPassword, setShowPassword] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [verified, setVerified] = useState(false);
  const [errors, setErrors] = useState({});



  const validateForm = () => {
    let newErrors = {};
    let valid = true;

    if (!firstName.trim()) {
      newErrors.firstName = "First name is required";
      valid = false;
    }
    if (!lastName.trim()) {
      newErrors.lastName = "Last name is required";
      valid = false;
    }
    if (!email.trim()) {
      newErrors.email = "Email is required";
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Enter a valid email";
      valid = false;
    }
    if (!password.trim()) {
      newErrors.password = "Password is required";
      valid = false;
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
      valid = false;
    }
    if (!dueDate) {
      newErrors.dueDate = "Please select due date";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

    const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const userData = {
      firstName,
      lastName,
      email,
      password,
      dueDate,
      verified,
    };

    try {
   await dispatch(AddUsers(userData))
     .then(() => {
      navigate("/dashboard/user-management");
    })
    .catch((err) => {
      console.error("Failed to add quiz:", err);
    });
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div className="content-wrapper" style={{ backgroundColor: "#f5f5f5" }}>
      <section className="main-section">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8">
              <form onSubmit={handleSubmit} className="p-4 shadow rounded bg-white">
                <h3 className="text-center mb-4">Add User</h3>

                {loading && (
                  <div className="text-center mb-3">
                    <PulseLoader color="#36d7b7" size={10} />
                  </div>
                )}

                {error && <div className="alert alert-danger">{error}</div>}
                {success && (
                  <div className="alert alert-success">
                    User added successfully!
                  </div>
                )}

                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={firstName}
                     // onChange={(e) => setFirstName(e.target.value)}
                       onChange={(e) => {
                      const value = e.target.value;
                      // Uppercase first letter, keep the rest as typed
                      const formatted = value.charAt(0).toUpperCase() + value.slice(1);
                      setFirstName(formatted);
                    }}
                      placeholder="Enter first name"
                    />
                    {errors.firstName && (
                      <small className="text-danger">{errors.firstName}</small>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={lastName}
                     // onChange={(e) => setLastName(e.target.value)}
                      onChange={(e) => {
                      const value = e.target.value;
                      // Uppercase first letter, keep the rest as typed
                      const formatted = value.charAt(0).toUpperCase() + value.slice(1);
                      setLastName(formatted);
                    }}
                      placeholder="Enter last name"
                    />
                    {errors.lastName && (
                      <small className="text-danger">{errors.lastName}</small>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter email"
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>

                 <div className="col-md-6 position-relative">
                    <label className="form-label">Password</label>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter password"
                    />
                    {/* Eye icon button */}
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        top: "38px",
                        right: "10px",
                        cursor: "pointer",
                      }}
                    >
                      {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                    </span>
                    {errors.password && (
                      <small className="text-danger">{errors.password}</small>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Due Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dueDate}
                      onChange={(e) => setDueDate(e.target.value)}
                    />
                    {errors.dueDate && (
                      <small className="text-danger">{errors.dueDate}</small>
                    )}
                  </div>

                  <div className="col-md-6 d-flex align-items-center">
                    <div>
                      <label className="form-label me-2">Verified</label>
                      <input
                        type="checkbox"
                        checked={verified}
                        onChange={(e) => setVerified(e.target.checked)}
                      />
                    </div>
                  </div>
                </div>

                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-success px-4"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddUser;